import * as React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/tailwind.css";
import { initErrorReporting } from "./shared/lib/metrics/errors";
import { initVitals } from "./shared/lib/metrics/vitals";
import { initSentry } from "./shared/lib/metrics/sentry";
import { saveStoredTenant } from "./shared/lib/tenantStorage";

import { startAdminPwa } from "@shared/lib/pwa";

startAdminPwa();

// Push deep links carry their tenant so the first API request uses the correct store context.
try {
  const tenantFromDeepLink = new URL(window.location.href).searchParams.get(
    "tenant",
  );
  if (
    tenantFromDeepLink &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      tenantFromDeepLink,
    )
  ) {
    saveStoredTenant(tenantFromDeepLink);
  }
} catch {
  // Ignore malformed URLs and continue with the last selected tenant.
}

async function enableMSW() {
  const flag = (import.meta as any).env?.VITE_ENABLE_MSW;
  // Never run MSW in production builds to avoid leaking mocks
  if (import.meta.env.PROD) return;
  const lsFlag =
    typeof window !== "undefined"
      ? window.localStorage.getItem("VITE_ENABLE_MSW")
      : null;
  const shouldUse =
    flag === "1" ||
    flag === "true" ||
    lsFlag === "1" ||
    lsFlag === "true" ||
    lsFlag === "on" ||
    flag === undefined ||
    flag === null ||
    flag === "";
  if (shouldUse) {
    try {
      // Use local mocks
      const { startBrowser } = await import("./mocks/browser");
      await startBrowser();
      // eslint-disable-next-line no-console
      console.info("[msw] Mock Service Worker started");
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("[msw] Failed to start worker", e);
    }
  }
}

enableMSW().finally(() => {
  const root = document.getElementById("root")!;
  try {
    initSentry();
  } catch {}
  try {
    initErrorReporting();
  } catch {}
  try {
    initVitals();
  } catch {}
  createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
